/* Turbo Parts — per-viewer vehicle title swap.
 * When the customer's saved car (finder / My Garage, localStorage 'tp-my-car')
 * matches a product's fitment tags but the title names a DIFFERENT donor vehicle
 * ("Toyota Auris/Corolla Hb Front Lower Bushing"), the DISPLAYED title becomes
 * "<their car> Front Lower Bushing ..." on collection cards and the product page.
 * Display-only: cart, checkout, emails and SEO keep the real title.
 */
(function () {
  var CAR_LS = 'tp-my-car';

  function slug(s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-')
      .replace(/-{2,}/g, '-').replace(/^-|-$/g, '');
  }

  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  // Which vehicle drives the title swap, in priority:
  //   1. a vehicle SEARCH the visitor just ran — routed to a fitment collection with
  //      ?fit=<label> (e.g. /collections/all/mm-bmw-4-series?fit=BMW%20428i); every
  //      product on that collection fits, so titles show exactly what they searched.
  //   2. else their saved My Garage car (localStorage 'tp-my-car').
  var carLabel = '', fitTag = '', makeStr = '', modelStr = '';
  var fitParam = null;
  try { fitParam = new URLSearchParams(location.search).get('fit'); } catch (e) {}
  var mmMatch = location.pathname.match(/\/collections\/[^/]+\/((?:mms|mm|yr)-[a-z0-9-]+)/i);
  if (fitParam && mmMatch) {
    carLabel = fitParam.replace(/\s+/g, ' ').trim();
    fitTag = mmMatch[1].toLowerCase();
    var bits = carLabel.split(' ');
    makeStr = bits.shift() || '';
    modelStr = bits.join(' ');
  } else {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem(CAR_LS) || 'null'); } catch (e) {}
    if (saved && saved.make && saved.model) {
      makeStr = saved.make; modelStr = saved.model;
      // Match at the customer's generation (mms-) when they picked one, so the "Fits your
      // <car>" chip and title swap only apply to parts that fit that exact generation.
      fitTag = saved.series
        ? 'mms-' + slug(saved.make) + '-' + slug(saved.model) + '-' + slug(saved.series)
        : 'mm-' + slug(saved.make) + '-' + slug(saved.model);
      carLabel = [saved.make, saved.model, saved.series].filter(Boolean).join(' ').replace(/\s+/g, ' ').trim();
    }
  }
  var hasCar = !!(carLabel && fitTag);
  // swap unless the title already names that exact car (make AND model/badge)
  var makeRe = hasCar ? new RegExp('\\b' + esc(makeStr) + '\\b', 'i') : null;
  var modelRe = hasCar ? new RegExp('\\b' + esc(modelStr) + '\\b', 'i') : null;

  // The part-description usually starts at a position/part word; everything
  // before it is the donor-vehicle phrase we replace.
  var BOUNDARY = new RegExp('\\b(' + [
    'Front', 'Rear', 'Left', 'Right', 'LH', 'RH',
    'Upper', 'Lower', 'Inner', 'Outer', 'Bushing', 'Bush',
    'Mounting', 'Mount', 'Shock', 'Strut', 'Control', 'Sway',
    'Stabiliser', 'Stabilizer', 'Link', 'Ball', 'Tie', 'Rod',
    'Boot', 'CV', 'Drive', 'Shaft', 'Oil', 'Seal',
    'Gasket', 'Filter', 'Pump', 'Radiator', 'Hose', 'Belt',
    'Tensioner', 'Idler', 'Alternator', 'Starter', 'Sensor', 'Coil',
    'Plug', 'Injector', 'Headlight', 'Taillight', 'Tailgate', 'Fog',
    'Lamp', 'Light', 'Mirror', 'Door', 'Window', 'Regulator',
    'Handle', 'Lock', 'Bumper', 'Grille', 'Guard', 'Fender',
    'Bonnet', 'Wiper', 'Washer', 'Brake', 'Pad', 'Rotor',
    'Disc', 'Caliper', 'Wheel', 'Hub', 'Bearing', 'Axle',
    'Spring', 'Clutch', 'Flywheel', 'Engine', 'Exhaust', 'Muffler',
    'Thermostat', 'Fan', 'Compressor', 'Condenser', 'Cabin', 'Air',
    'Fuel', 'Ignition', 'Battery', 'Spark', 'Crossmember', 'Arm',
    'Bar', 'End', 'Kit', 'Set', 'O-Ring', 'Ring',
    'Joint', 'Nut', 'Bolt', 'Screw', 'Clip', 'Grommet',
    'Cap', 'Valve', 'Relay', 'Switch', 'Solenoid', 'Bracket',
    'Trim', 'Moulding', 'Weatherstrip', 'Pipe', 'Gaiter', 'Cover',
    'Sump', 'Differential', 'Gearbox', 'Transmission', 'Steering', 'Suspension',
    'Tripod', 'Crankshaft', 'Camshaft', 'Pulley', 'Flange', 'Yoke', 'Knuckle',
    'Booster', 'Reservoir', 'Overflow', 'Expansion', 'Actuator', 'Blower',
    'Resistor', 'Motor', 'Tank'
  ].join('|') + ')\\b');

  function swappedTitle(t) {
    if (!t) return null;
    if (makeRe.test(t) && modelRe.test(t)) return null;  // already their exact car
    var m = BOUNDARY.exec(t);
    if (!m || m.index < 3) return null;             // no vehicle prefix to swap
    return carLabel + ' ' + t.slice(m.index);
  }

  // Green "✓ Fits your <car>" reassurance chip on any card that fits the active car.
  function addFitsChip(card, label) {
    var content = card.querySelector('.product-card__content');
    if (!content || content.querySelector('.tp-fits-chip')) return;
    var chip = document.createElement('span');
    chip.className = 'tp-fits-chip';
    chip.setAttribute('aria-label', 'Fits your ' + label);
    chip.innerHTML = '<span class="tp-fits-chip__tick" aria-hidden="true">✓</span> Fits your ' + label;
    content.insertBefore(chip, content.firstChild);
  }

  // Rewrite a fitting card's DISPLAYED title from the donor vehicle to the customer's car.
  // Precise + safe: only nodes whose text IS the product's real title are touched (never
  // price/badges); if there is no donor-vehicle prefix to swap, the title is left as-is.
  // The product page's <h1> is swapped the same way (see boot), so grid and page agree.
  function swapCardTitles(card) {
    var hid = card.querySelector('.product-card__link .visually-hidden');
    var real = hid ? hid.textContent.trim() : '';
    if (!real) return;
    var swapped = swappedTitle(real);
    if (!swapped) return;
    card.querySelectorAll('[role="heading"], h1, h2, h3, h4, h5, .visually-hidden').forEach(function (n) {
      if (n.textContent.trim() === real) n.textContent = swapped;
    });
  }

  function fixCard(card) {
    if (card.dataset.tpFitDone) return;
    var fits = ',' + (card.getAttribute('data-fit') || '') + ',';
    if (fits.indexOf(',' + fitTag + ',') < 0) return;
    card.dataset.tpFitDone = '1';
    swapCardTitles(card);          // show the customer's car instead of the donor vehicle
    addFitsChip(card, carLabel);   // + green "Fits your <car>" reassurance tick
  }

  // Green "✓ Fits your <car>" banner on the product page itself (title stays untouched).
  function addProductFitBanner(label) {
    if (document.getElementById('tp-fits-banner')) return;
    if (!document.getElementById('tp-fits-banner-style')) {
      var st = document.createElement('style');
      st.id = 'tp-fits-banner-style';
      st.textContent = '#tp-fits-banner{display:inline-flex;align-items:center;gap:8px;' +
        'background:#E7F5EC;color:#1B7A3E;font-family:Manrope,sans-serif;font-weight:700;' +
        'font-size:14px;line-height:1.2;padding:10px 15px;border-radius:999px;margin:2px 0 16px;' +
        'border:1px solid #BCE3C9;}' +
        '#tp-fits-banner .tp-fb-tick{display:inline-flex;width:18px;height:18px;border-radius:50%;' +
        'background:#1B7A3E;color:#fff;align-items:center;justify-content:center;font-size:12px;flex:0 0 auto;}';
      document.head.appendChild(st);
    }
    var h1 = document.querySelector('main h1') || document.querySelector('h1');
    if (!h1) return;
    var b = document.createElement('div');
    b.id = 'tp-fits-banner';
    b.setAttribute('aria-label', 'Fits your ' + label);
    b.innerHTML = '<span class="tp-fb-tick" aria-hidden="true">✓</span> Fits your ' + label;
    h1.parentNode.insertBefore(b, h1.nextSibling);   // directly under the product title
  }

  // ---- "Fits <your model>" confirmation chip on search result cards ----
  // Trigger: the current search query (?q=) names an engine/variant badge this part
  // fits (data-fits-badges, e.g. "BMW 428i,BMW 435i"). Display-only, additive.
  var searchQ = '';
  try {
    if (location.pathname.indexOf('/search') === 0 || /[?&]q=/.test(location.search)) {
      searchQ = (new URLSearchParams(location.search).get('q') || '').toLowerCase();
    }
  } catch (e) {}

  function chipLabel(card) {
    if (!searchQ) return null;
    var raw = card.getAttribute('data-fits-badges');
    if (!raw) return null;
    var badges = raw.split(',');
    for (var i = 0; i < badges.length; i++) {
      var b = badges[i].trim();
      if (!b) continue;
      var variant = b.split(' ').slice(1).join(' ').toLowerCase();  // "428i"
      if (variant && searchQ.indexOf(variant) >= 0) return b;       // display "BMW 428i"
    }
    return null;
  }

  function addChip(card) {
    if (card.dataset.tpChipDone) return;
    var label = chipLabel(card);
    if (!label) return;
    card.dataset.tpChipDone = '1';
    var content = card.querySelector('.product-card__content');
    if (!content || content.querySelector('.tp-fits-chip')) return;
    var chip = document.createElement('span');
    chip.className = 'tp-fits-chip';
    chip.setAttribute('aria-label', 'Fits ' + label);
    chip.innerHTML = '<span class="tp-fits-chip__tick" aria-hidden="true">✓</span> Fits ' + label;
    content.insertBefore(chip, content.firstChild);
  }

  var pending = false;
  function run() {
    pending = false;
    if (hasCar) document.querySelectorAll('product-card[data-fit]').forEach(fixCard);
    if (searchQ) document.querySelectorAll('product-card[data-fits-badges]').forEach(addChip);
  }

  function boot() {
    run();
    new MutationObserver(function () {             // async grids / recommendations
      if (!pending) { pending = true; setTimeout(run, 120); }
    }).observe(document.body, { childList: true, subtree: true });

    if (hasCar && location.pathname.indexOf('/products/') >= 0) {
      var handle = location.pathname.split('/products/')[1].split(/[/?#]/)[0];
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          if ((p.tags || []).indexOf(fitTag) < 0) return;   // this part fits the customer's car
          var h1 = document.querySelector('main h1') || document.querySelector('h1');
          if (h1) {                                          // swap the page title to match the grid
            var sw = swappedTitle(h1.textContent.trim());
            if (sw) h1.textContent = sw;
          }
          addProductFitBanner(carLabel);                    // green ✓ "Fits your <car>" tick
        }).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
